<template>
    <div class="mb-4">
        <v-text-field :value="value" label="Suma investície" type="number" step="10" min="10" max="1000000" suffix="€"
            outlined dense hide-details="auto" :rules="rules" :error="hasError" :success="isValid"
            @input="$emit('input', parseFloat($event))" @focus="$event.target.select()"
            @keyup.enter="$emit('quick-invest')">
            <template v-slot:prepend-inner>
                <v-icon :color="fieldColor">mdi-currency-eur</v-icon>
            </template>
            <template v-slot:append-outer>
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small v-bind="attrs" v-on="on">
                            <v-icon small color="primary">mdi-lightning-bolt</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item v-for="preset in presets" :key="preset.value"
                            @click="$emit('input', preset.value)">
                            <v-list-item-content>
                                <v-list-item-title>{{ formatCurrency(preset.value) }}</v-list-item-title>
                                <v-list-item-subtitle>{{ preset.label }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </v-text-field>

        <!-- Live validation feedback -->
        <v-expand-transition>
            <div v-if="value > 0" class="mt-2">
                <v-alert v-if="hasError" dense outlined type="error" class="mb-0">
                    {{ errorMessage }}
                </v-alert>
                <v-alert v-else-if="isValid" dense outlined type="success" class="mb-0">
                    <v-icon left small>mdi-check</v-icon>
                    Investícia je v poriadku!
                </v-alert>
            </div>
        </v-expand-transition>
    </div>
</template>

<script>
import { formatCurrency } from '@/utils/investment-math';

export default {
    name: 'CalculatorInput',
    props: {
        value: { type: Number, default: 0 },
        rules: { type: Array, default: () => [] },
        presets: { type: Array, default: () => [] },
        hasError: { type: Boolean, default: false },
        isValid: { type: Boolean, default: false },
        errorMessage: { type: String, default: '' }
    },
    computed: {
        fieldColor() {
            if (!this.value) return 'grey';
            return this.isValid ? 'success' : 'error';
        }
    },
    methods: {
        formatCurrency
    }
}
</script>

<style scoped>
.v-text-field>>>input {
    font-weight: 500;
    font-size: 1.1rem;
}
</style>
